import { useEffect, useReducer } from 'react';

type State = {
  hasOpenMenu: boolean;
};

const currentState: State = { hasOpenMenu: false };
const prevState = { ...currentState };
const openMenuListeners = new Set<() => void>();

function useRerenderListener(shouldRerender: () => boolean): void {
  const [, forceUpdate] = useReducer((x) => x + 1, 0);
  useEffect(() => {
    const listener = () => {
      if (shouldRerender()) {
        forceUpdate();
      }
    };
    openMenuListeners.add(listener);
    return () => {
      openMenuListeners.delete(listener);
    };
  });
}

/**
 * Returns true if any menu is currently open.
 */
export function useHasOpenMenu(): boolean {
  useRerenderListener(() => currentState.hasOpenMenu !== prevState.hasOpenMenu);

  return currentState.hasOpenMenu;
}
